import { render, staticRenderFns } from "./videoNote.vue?vue&type=template&id=7b451c0e&scoped=true"
import script from "./videoNote.vue?vue&type=script&lang=js"
export * from "./videoNote.vue?vue&type=script&lang=js"
import style0 from "./videoNote.vue?vue&type=style&index=0&id=7b451c0e&prod&lang=scss&scoped=true"
import style1 from "./videoNote.vue?vue&type=style&index=1&id=7b451c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b451c0e",
  null
  
)

export default component.exports